import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_employee_topup_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_plan_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_actual_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_property_json: fromDatatype.JsonDatatypeInterface;
  recurring_notification_json: fromDatatype.JsonDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  generated_claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  topup_amount:fromDatatype.IntegerDatatypeInterface;
  validity_period_in_days: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_months: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generated_claim_account_txn_line_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_aat_claim_account_employee_topup_event_RowClass implements bl_aat_claim_account_employee_topup_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_plan_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_actual_execute_date: fromDatatype.TimestampTzDatatypeInterface;
  recurring_property_json: fromDatatype.JsonDatatypeInterface;
  recurring_notification_json: fromDatatype.JsonDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  generated_claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_account_hdr_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  topup_amount:fromDatatype.IntegerDatatypeInterface;
  validity_period_in_days: fromDatatype.IntegerDatatypeInterface;
  validity_period_in_months: fromDatatype.IntegerDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generated_claim_account_txn_line_guid: fromDatatype.GuidDataFieldInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
